import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getConfigPtMonMedidor } from './services'

const initialState: any = {
  status: "",
  data: {}
}

export const actionGetConfigPtMonMedidor: any = createAsyncThunk<any, any>(
  "ACTION_GET_CONFIG_PT_MON_MEDIDOR",
  async (data, { getState }: any) => {
    const {
      modulosByCentral: {
        entradaSelected: {
          modulo: {
            idCentral,
            adrModulo,
          },
          entrada
        }
      },
    } = getState()
    return getConfigPtMonMedidor({
      idCentral,
      adrModulo,
      idEntrada: entrada.id,
    })
  }
)

const sliceGetConfigPtMonMedidor = createSlice({
  name: "GET_CONFIG",
  initialState,
  reducers: {
      actionResetGetConfigPtMonMedidor: (state) => {
      state.data = {}
    }
  },
  extraReducers: {
    [actionGetConfigPtMonMedidor.pending]: (state) => {
      state.status = "loading"
    },
    [actionGetConfigPtMonMedidor.fulfilled]: (state, { payload }) => {
      state.status = "success"
      state.data = {
        ...payload,
        hrMsgEscaladaNV2: payload.timeMsgEscaladaNV2?.split(":")[0],
        minMsgEscaladaNV2: payload.timeMsgEscaladaNV2?.split(":")[1],
        hrMsgEscaladaNV3: payload.timeMsgEscaladaNV3?.split(":")[0],
        minMsgEscaladaNV3: payload.timeMsgEscaladaNV3?.split(":")[1],
      }
    },
    [actionGetConfigPtMonMedidor.rejected]: (state, err) => {
      console.log(err)
      state.status = "error"
    },
  }
})

export default sliceGetConfigPtMonMedidor.reducer
export const { actionResetGetConfigPtMonMedidor } = sliceGetConfigPtMonMedidor.actions